export const baseURL = process.env.REACT_APP_SITEURL;

export const cloneDeep = require("lodash.clonedeep");

export const maxImageSize = 1 * 1024 * 1024;

export const booleanOptions = {
  Yes: true,
  No: false,
}

export const subStepStatus = {
  Done: 1,
  OnProgress: 2,
  Awaiting_Verification: 3,
  Waiting: 0
}

export enum suiteType {
  google = "google",
  microsoft = "microsoft"
}

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const urlRegex =
  /^https?:\/\/([a-z0-9]{2,}(-[a-z0-9]{2,})*\.)+[a-z0-9]{2,6}(\/[a-z0-9#?=&%\/\-_\.]*)?$/i;

export const AgentType = [
  { id:1, name: "General Agent", value: 1 },
  { id:2, name: "College Agent", value: 2 },
  { id:3, name: "Transaction Details Agent", value: 3 },
  { id:4, name: "Course Agent", value: 4 }
];

export enum AiClient {
  BUDU = "BUDU",
  COPILOT = "CO-Pilot",
}

export enum AiChatRoles {
  USER = "user",
  ASSISTANT = "assistant",
}

export const DEFAULT_OLLAMA_MODEL = "qwen2.5:7b";